import { selectFeatureFlag } from '@flopflip/react-redux';
import _ from 'lodash';

export const selectFeatureFlagByKey = key => selectFeatureFlag(_.camelCase(key), ['memory']);
